var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.333,
    height: 34.667,
    viewBox: "0 0 64.333 34.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(-121 -1975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    "data-name": "Trazado 334",
    d: "M185.333,1995.667a2,2,0,0,0-2-2h-16a2,2,0,0,0-1.9,1.367l-1.544,4.633H123.333a2,2,0,1,0,0,4h40.559l1.544,4.632a2,2,0,0,0,1.9,1.368h16a2,2,0,1,0,0-4H168.775l-.666-2h15.224a2,2,0,1,0,0-4H168.109l.666-2h14.558A2,2,0,0,0,185.333,1995.667Z",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    "data-name": "Trazado 335",
    d: "M121,1985a2,2,0,0,0,2,2h60a2,2,0,0,0,2-2v-4a2,2,0,0,0-1.76-1.986l-33-4a2,2,0,0,0-2.18,1.5L146.438,1983H123A2,2,0,0,0,121,1985Zm30.512-5.8L181,1982.772V1983H150.561Z",
    fill: "#e5bda0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.c9a27dcc745873a65018e9ae7e224bee.svg";
export { ForwardRef as ReactComponent };